import { fieldIsVulcanOrderWLN, fieldSalesRepInfo, fieldIsPureFibreEastLeadWLN } from '../../utils/constant';
import { getFieldValue } from '../utils';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { getLocale } from '../../misc';

const locale = getLocale();

const {
  WLS: {
    _yes, _no
  }
} = locale === 'en-US' ? EN : FR;

const PrequalificationHelpers = ({
  isCreateOrderButtonVisible,
  formFields,
  fieldName
}) => {
  const isVulcanOrder = getFieldValue(fieldIsVulcanOrderWLN, formFields);
  const isPureFibreEastLead = getFieldValue(fieldIsPureFibreEastLeadWLN, formFields);

  if (fieldName === fieldSalesRepInfo) {
    return true;
  }

  if (fieldName === fieldIsPureFibreEastLeadWLN && isPureFibreEastLead) {
    isCreateOrderButtonVisible(false);
  }

  // if (fieldName === fieldIsVulcanOrderWLN && !isVulcanOrder) {
  //   isCreateOrderButtonVisible(true);
  // }

  // if (fieldName === fieldIsVulcanOrderWLN && isVulcanOrder === _no) {
  //   isCreateOrderButtonVisible(false);
  // } else if (fieldName === fieldIsVulcanOrderWLN && isVulcanOrder === _yes) {
  //   isCreateOrderButtonVisible(true);
  // }
};

export default PrequalificationHelpers;
